import { useNavigate } from 'react-router-dom';
import Button from 'common/components/button';
import BgLayout from 'common/components/bg';
import Tracker from 'components/auth/welcome/tracker';
import ListItem from 'common/components/list-item';
import { FaCheck, FaComment, FaCreditCard, FaFileSignature, FaHouseChimney, FaQuoteLeft } from 'react-icons/fa6';
import { ButtonGroup, Flex, Text } from '@chakra-ui/react';
import { HiCheckBadge } from 'react-icons/hi2';
import { FaCommentAlt } from 'react-icons/fa';
import { AiOutlineComment } from 'react-icons/ai';
import { MdOutlineComment, MdOutlineModeComment } from 'react-icons/md';
import { iconPositionEnum } from 'common/utils/enums';
import PlanCreateButton from 'components/plans/plan-create-button';
import ContactSupportModal from 'components/shared/help-button';

const Welcome = () => {
  const navigate = useNavigate();

  // Show the steps to sign up in the signup sidebar
  const sidebarSteps = (
    <Flex className='flex-col gap-4'>
      <Flex className='flex-col gap-6 py-6 px-6 border border-gray-200 bg-white rounded-md w-full'>
        <Flex className='flex-col gap-1 items-start'>
          <h3 className='text-xl font-medium'>What's Next?</h3>
          <Text className='text-base text-gray-500'>
            Get covered in a few simple steps:
          </Text>
        </Flex>
        <ListItem
          title='Create a free account'
          description='Create a free ReLease member account online.'
          ListIcon={FaCheck}
          complete
          line
        />
        <ListItem
          title='Get a free quote'
          description="You’re seconds away from an estimate. Create as many quotes as you’d like at as many properties as you’d like."
          ListIcon={FaQuoteLeft}
          line
        />
        <ListItem
          title="Choose a rental"
          description="Apply for a rental and finalize your lease term, monthly rent price, and unit layout."
          ListIcon={FaHouseChimney}
          line
        />
        <ListItem
          title='Purchase coverage'
          description='Provide some personal details and purchase your plan. The ReLease team will reach out to you and confirm your coverage.'
          ListIcon={FaCreditCard}
        />
        <ListItem
          title='Sign your lease'
          description='Eligible renters must purchase coverage within 7 days of signing a lease.'
          ListIcon={FaFileSignature}
        />      
      </Flex>
      <ButtonGroup className='justify-center'>
        <ContactSupportModal
          buttonProps={{
            theme: 'secondary',
            linkId: 'speakWithSupportButton',
            title: 'Contact Support',
            fixedHeight: false,
            className: 'self-start',
            size: 'sm',
            iconPosition: iconPositionEnum.LEFT,
            Icon: MdOutlineModeComment,
          }}
        />
      </ButtonGroup>
    </Flex>
  );

  return (
    <>
      <BgLayout aside={sidebarSteps}>
        <div className='flex flex-col gap-6 items-center justify-center text-center'>
          <h1 className='font-display tracking-tight text-4xl'>
            Welcome to ReLease
          </h1>

          <div className='flex flex-col gap-2'>
            <p className='text-base font-normal'>
              When you’re covered with a flexible lease option from ReLease, you can move out whenever you want or need, no questions asked.
            </p>
            <p className='text-base text-gray-500 font-normal'>
              Get a free quote and see how much you can save.
            </p>
          </div>
        </div>
        <Flex className='flex-col gap-6 md:gap-8 w-full'>
          <ButtonGroup className='flex-col items-center gap-4'>            
            <PlanCreateButton
              mode='quote'
              title='Get a Free Quote'
              theme='primary'
            />    
          </ButtonGroup>
          <div className='flex w-full h-[1px] bg-gray-200 relative items-center justify-center'>
            <Text className='text-sm text-gray-500 bg-white px-3'>
              Already signed a lease?
            </Text>
          </div>
          <ButtonGroup className='justify-center items-center flex-col sm:flex-row gap-4 sm:gap-1'>
            <PlanCreateButton
              mode='purchase'
              title='Purchase Now'
              theme='secondary'
            />
          </ButtonGroup>
        </Flex>
      </BgLayout>
      <Tracker />
    </>
  );
};

export default Welcome;
